export function number_format(a) {
  if( a == null) {
    return 0 + '원';
  }
  return a.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')+'원';
}

export function number_input_format(a) {
  if (a === null || a === undefined) {
    return 0;  // 숫자 0 반환
  }
  return (a.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')+'');
}


export function getUrlVars() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi,
    function(m,key,value) {
      if( value.indexOf('#') != -1 ){
        value = value.split('#')[0];
      }
      vars[key] = value;
    });
    return vars;
}

export function getiOS()
{
  if( window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.moreAction ){
    return true;
  } else {
    return false;
  }
}
